import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'react-router-dom';
import { fetchDraftRegulationById } from './Regulation.services';

export const useRegulation = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const isHistory = searchParams.get('history') === 'true';

  const query = useQuery({
    queryKey: ['draftRegulation', id, isHistory],
    queryFn: () => fetchDraftRegulationById(id, isHistory),
    enabled: !!id,
    retry: false,
    staleTime: 1000 * 60 * 3,
  });
  
  const isTrusted = query.isFetchedAfterMount || !query.isStale;

  return { id, isHistory, ...query, data: isTrusted ? query.data : undefined };
};
